import { AUTH_ROUTES } from '@lib/constants/apis';

const AUTH_ROUTE_PATHS = Object.values(AUTH_ROUTES);

/**
 * Returns true if `path` is one of the AUTH_ROUTES, with these matching rules:
 * - Query string and hash are stripped before comparison.
 * - Exact match or prefix-with-`/` match (so `/login/foo` matches `/login`,
 *   but `/loginx` does not).
 *
 * Falsy input (null, undefined, empty string) returns false — the safe default
 * is "treat as non-auth route" so a missing path can't accidentally trap the
 * user.
 */
export function isAuthRoutePath(path: string | null | undefined): boolean {
  if (!path) return false;
  const pathOnly = path.split(/[?#]/)[0];
  return AUTH_ROUTE_PATHS.some(
    p => pathOnly === p || pathOnly.startsWith(`${p}/`)
  );
}
